import React, { useState } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../styles/floatingForm.css";

const AddUser = () => {
  const navigate = useNavigate();

  // Form fields
  const [employeeId, setEmployeeId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [errors, setErrors] = useState({});

  // --------------------------------------------------
  // CANCEL
  // --------------------------------------------------

  const handleCancel = () => {
    setEmployeeId("");
    setName("");
    setEmail("");
    setPassword("");
    setErrors({});

    navigate("/users");
  };

  // --------------------------------------------------
  // SUBMIT
  // --------------------------------------------------

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!employeeId.trim()) {
      newErrors.employeeId = "Employee Id is required";
    }

    if (!name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Invalid email format";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      toast.error(
        "Please fill all required fields correctly"
      );

      return;
    }

    setErrors({});

    const formData = new FormData();

    formData.append("emplyid", employeeId);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("password", password);

    try {
      const response = await api.post(
        "/adminusers/add",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        toast.success("User created successfully!");

        // Go back to user list
        navigate("/users");
      } else {
        toast.error("Failed to create User");
      }
    } catch (error) {
      console.error("Error creating User:", error);

      toast.error("Error creating User");
    }
  };

  return (
    <div className='floating-form-container' >
      <div className="heading">
        <h2>User Details</h2>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-container">

          {/* Basic Info */}
          <div className="section-1">
            

            <div className="input-container-floating-form wid-50">
              <label>Employee Id</label>
              <input
                type="text"
                className={`form-control ${errors.employeeId ? 'is-invalid' : ''}`}
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                placeholder="Enter Employee Id"
                />
                {errors.employeeId && <span className='text-danger small'>{errors.employeeId}</span>}

            </div>

            <div className="input-container-floating-form wid-50">
              <label>Name</label>
              <input
                type="text"
                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter Name"
                />
                {errors.name && <span className='text-danger small'>{errors.name}</span>}

            </div>

            <div className="input-container-floating-form wid-50">
              <label>Email</label>
              <input
                type="email"
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Email"
                />
                {errors.email && <span className='text-danger small'>{errors.email}</span>}

            </div>

            <div className="input-container-floating-form wid-50">
              <label>Password</label>
              <input
                type="password"
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                />
                {errors.password && <span className='text-danger small'>{errors.password}</span>}

            </div>

          </div>

            <div className="form-btn-container">
            <button type='submit'>Add User</button>
            <button type='button' onClick={handleCancel}>Cancel</button>
            </div>

        </div>



      </form>
    </div>
  );
};

export default AddUser;
